//@flow
import React, {forwardRef, useState} from 'react';
import {
  IconButton,
  InputAdornment,
  InputBase,
  makeStyles,
} from '@material-ui/core';
import {Clear} from '@material-ui/icons';
import {colors} from '../../assets/styles/colors';
import SearchIcon from '../icons/SearchIcon';

type Props = {
  label?: string,
  placeholder?: string,
  value?: string,
  disabled?: boolean,
  error?: boolean,
  helperText?: string,
  className?: string,
  fullWidth?: boolean,
  startIcon?: React$Node,

  onChange?: (value: string) => void,
  onClear?: () => void,
  onSubmit?: (value: string) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '2rem',
    backgroundColor: colors.grey200,
    padding: '0.25rem .5rem',
    color: colors.grey600,

    '& .MuiInputBase-input': {
      padding: '0.5rem 0',
    },
  },
}));

export default forwardRef<Props, any>(function SearchInput(props, ref) {
  const {
    onChange,
    onClear,
    onSubmit,
    value = '',
    className,
    startIcon,
    ...textFileProps
  } = props;

  const classes = useStyles();

  const [innerValue, setInnerValue] = useState(value);

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(innerValue);
    }
  };

  const handleClear = () => {
    setInnerValue('');
    onSubmit && onSubmit('');
    onClear && onClear();
    onChange && onChange('');
  };

  return (
    <InputBase
      {...textFileProps}
      className={`${classes.root} ${className || ''}`}
      value={innerValue}
      onChange={e => {
        setInnerValue(e.target.value);
        if (!onChange) return;
        onChange(e.target.value);
      }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          handleSubmit();
        }
      }}
      ref={ref}
      startAdornment={
        <InputAdornment position="start">
          {startIcon ? startIcon : <SearchIcon width={24} height={24} />}
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label="buscar"
            size="small"
            onClick={handleClear}
            color="primary"
            edge="end"
          >
            <Clear />
          </IconButton>
        </InputAdornment>
      }
    />
  );
});
